<script>
	import ExerciseBankSidebar from './ExerciseBankSidebar.svelte';
	import MCQExerciseDisplay from './MCQExerciseDisplay.svelte';
	import { push } from 'svelte-spa-router';

	let activePage = 'uzduociu-bankas';

	function handlePageChange(pageId) {
		if (pageId === 'ikelti') {
			// Navigate to upload exercise page
			push('/exercise-bank/upload');
		} else if (pageId === 'pradzia') {
			// Navigate to landing page
			push('/exercise-bank');
		} else {
			activePage = pageId;
		}
	}
</script>

<div class="app-container">
	<!-- Sidebar -->
	<ExerciseBankSidebar {activePage} onPageChange={handlePageChange} />

	<!-- Main Content -->
	<main class="main-content">
		<div class="page-container">
			<MCQExerciseDisplay />
		</div>
	</main>
</div>

<style>
	.app-container {
		display: flex;
		height: 100vh;
		background-color: #f9fafb;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100vw;
		z-index: 1000;
	}

	/* Main Content Styles */
	.main-content {
		flex: 1;
		overflow: auto;
	}

	.page-container {
		max-width: 1280px;
		margin: 0 auto;
		padding: 48px 32px;
	}

	/* Responsive Design */
	@media (max-width: 768px) {
		.app-container {
			flex-direction: column;
		}

		.page-container {
			padding: 24px 16px;
		}
	}
</style>

